<template>
  <div v-if="isDesktop" class="components-notifications-dropdown">
    <b-dropdown
      variant="link"
      class="hide-footer"
      id="notification-dropdown"
      toggle-class="text-decoration-none"
      dropleft
      no-caret
      size="sm"
    >
      <template #button-content>
        <div class="notification-wrapper">
          <i class="icon-bell-2 lead"></i>
          <span v-if="data.not_visualized" class="notification-count">{{
            data.not_visualized
          }}</span>
        </div>
      </template>
      <b-dropdown-text class="mb-4 px-4 pt-3 font-weight-bold text-light">
        <div class="d-flex align-items-center ">
          <div class="flex-fill">
            Notificações
          </div>
          <button
            class="btn btn-small text-success"
            @click="checkAll"
            :disabled="!data.itens.length"
          >
            <loading :show="loadingClear">
              marcar todas como lido
            </loading>
          </button>
        </div>
      </b-dropdown-text>
      <loading :show="showLoading">
        <b-dropdown-item v-if="!data.itens.length" disabled>
          Nenhum item para exibir
        </b-dropdown-item>
        <template v-if="data.itens.length">
          <div class="scroll-content px-2">
            <notification-item
              v-for="(notification, i) in sortedItems"
              :key="`notification-${i}`"
              :item="notification"
              @update="updateWithoutFeedback"
            />
          </div>
        </template>
      </loading>
    </b-dropdown>
  </div>
  <div v-else class="components-notifications-dropdown">
    <router-link :to="{ name: 'notifications' }" class="notification-wrapper">
      <i class="icon-bell-2 lead"></i>
      <span class="notification-count">{{ data.not_visualized }}</span>
    </router-link>
  </div>
</template>
<script>
import NotificationItem from "./NotificationItem.vue";
import { sortByDesc } from "@/functions/helpers";
export default {
  components: { NotificationItem },
  data() {
    return {
      showLoading: false,
      loadingClear: false,
      data: {
        itens: [], //the correct is items, but api params is named itens
        not_visualized: 0,
        not_read: 0
      }
    };
  },
  mounted() {
    this.dispatch();
  },
  computed: {
    sortedItems() {
      return sortByDesc(this.data.itens, "created_at");
    },
    isDesktop() {
      return window.innerWidth > 768;
    }
  },
  methods: {
    dispatch() {
      this.showLoading = true;
      this.$store
        .dispatch("user/notifications")
        .then(data => {
          this.data = data;
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
    checkAll() {
      this.loadingClear = true;
      this.$store
        .dispatch("user/check_all_notifications")
        .then(() => {
          this.$message.success(
            "As notificações foram marcadas com visualizadas!"
          );
          this.dispatch();
        })
        .finally(() => {
          this.loadingClear = false;
        });
    },
    updateWithoutFeedback() {
      this.$store.dispatch("user/notifications").then(data => {
        this.data = { ...data };
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.components-notifications-dropdown {
  display: flex;
  align-items: center;
  .notification-wrapper {
    position: relative;

    @media screen and (max-width: 768px) {
      padding: 1rem;
    }

    i {
      font-size: 25px;
      color: #fff;
    }
    .notification-count {
      position: absolute;
      top: -20%;
      right: -10%;

      background: #2db563;
      border-radius: 50%;
      font-size: 12px;
      height: 17px;
      width: 17px;
      text-decoration: none;

      display: flex;
      justify-content: center;
      align-items: center;

      color: #fff;

      @media screen and (max-width: 768px) {
        top: 10%;
        right: 20%;
      }
    }
  }

  ::v-deep .dropdown-toggle:before {
    content: none;
  }

  ::v-deep .dropdown-menu {
    background: #111112;
    width: 460px;
    @media screen and (max-width: 768px) {
      width: 100vw;
    }
  }

  .scroll-content {
    scroll-behavior: smooth;
    overflow-y: scroll;
    max-height: 400px;

    @media screen and (max-width: 768px) {
      max-height: 300px;
    }

    &::-webkit-scrollbar {
      background: #2c2c2c;
      border-radius: 50%;
      width: 8px;
    }

    /* Track */
    &::-webkit-scrollbar-track {
      background: #0a0a0a;
    }

    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: #888;
      border-radius: 8px;
    }

    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  }

  .btn-small {
    font-size: 12px !important;
  }
}
</style>
